var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main-form" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row center-xs" }, [
            _c("div", { staticClass: "col-xs-12 col-md-8 scroll-container" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("textarea-field", {
                    attrs: { stretch: "", id: "contenido", readonly: "" },
                    model: {
                      value: _vm.terminos_condiciones.contenido,
                      callback: function($$v) {
                        _vm.$set(_vm.terminos_condiciones, "contenido", $$v)
                      },
                      expression: "terminos_condiciones.contenido"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-buttons" }, [
          _c("div", { staticClass: "row center-xs" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("p", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.check_aceptar,
                          expression: "check_aceptar"
                        }
                      ],
                      attrs: { id: "check_aceptar", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.check_aceptar)
                          ? _vm._i(_vm.check_aceptar, null) > -1
                          : _vm.check_aceptar
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.check_aceptar,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.check_aceptar = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.check_aceptar = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.check_aceptar = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Acepto los términos y condiciones")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-info btn--text",
                    attrs: { tooltip: "Descargar archivo PDF", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.botonDescargarPdf()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file-pdf-o" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Descargar")])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row center-xs" }, [
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn-success btn--bigger",
                  attrs: { disabled: !_vm.check_aceptar, type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.aceptar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-check" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Aceptar")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mb-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--bigger",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.cancelar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-times-circle" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Cancelar")])
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Términos y condiciones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e992e9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e992e9a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/terminos-condiciones/AceptarTerminosCondiciones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1e992e9a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/terminos-condiciones/AceptarTerminosCondiciones.vue
// module chunks = 0